import { NavigationContainer } from '@react-navigation/native'
import React from 'react'
import { LogBox, StatusBar, StyleSheet, View } from 'react-native'
import { MD3DarkTheme, Provider as PaperProvider } from 'react-native-paper'
import PersistedProvider from 'src/redux/provider'
import AppNavigator from './navigation/AppNavigator'

const background = '#132936'
const card = '#193546'

const theme = {
  ...MD3DarkTheme,
  roundness: 0,
  colors: {
    ...MD3DarkTheme.colors,

    elevation: {
      level0: 'transparent',
      level1: card,
      level2: card,
      level3: card,
      level4: card,
      level5: card,
    },

    primary: '#24C069',
    accent: '#f1c40f',
    backgroundColor: background,
    backdrop: background,
    surface: background,
    text: 'white',
    vegan: '#47D655',
    vegetarian: '#3AA363',
    dairyFree: '#9DA3D1',
    glutenFree: '#B8532E',
    lowFodmap: '#D4A20D',
  },
}

const App = () => {
  LogBox.ignoreLogs(['Warning: ...']) // Ignore log notification by message
  LogBox.ignoreAllLogs() //Ignore all log notifications

  return (
    <PersistedProvider>
      <PaperProvider theme={theme}>
        <StatusBar backgroundColor={background} barStyle={'light-content'} />
        <NavigationContainer linking={true}>
          <View style={styles.container}>
            <AppNavigator />
          </View>
        </NavigationContainer>
      </PaperProvider>
    </PersistedProvider>
  )
}

const styles = StyleSheet.create({
  topContainer: {
    flex: 1,
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  container: {
    flex: 1,
  },
})

export default App
